import { TweenLite, ScrollToPlugin } from 'gsap/all';
import lazySizes from './lib/lazysizes';
import $ from './core/Dom';
import Viewport from './core/Viewport';
import Components from './core/Components';
import colorchanger from './modules/colorchanger';
import parallaxer from './modules/Parallaxer';

// Register the plugin manually
if (TweenLite && ScrollToPlugin) {
    TweenLite._plugins = TweenLite._plugins || {};
    TweenLite._plugins.ScrollToPlugin = ScrollToPlugin;
}

/*
*   Bootstrap app
*
 */
const init = () => {
    Viewport.init();
    Components.init();
    Viewport.initTabbing();
    lazySizes.init();
    parallaxer.init();

    colorchanger();

    const $body = $('body');

    $body.on('click', '[data-scroll-to-anchor]', (e) => {
        e.preventDefault();
        const $trigger = $(e.triggerTarget);

        if ($trigger.length > 0) {
            const targetHref = $trigger.attr('href');
            const $target = $(targetHref);

            if ($target.length > 0) {
                TweenLite.to(window, 1.1, { scrollTo: $target.offset().top, ease: Quint.easeInOut });
            }
        }
    });

    $body.on('click', '[data-scroll-to-location-link]', (e) => {
        e.preventDefault();
        const $target = $body.find('[data-interactivemap]');

        if ($target.length > 0) {
            TweenLite.to(window, 1.1, { scrollTo: $target.offset().top, ease: Quint.easeInOut });
        }
    });

    $body.find('a[data-will-have-skew], .wysiwyg a').each(el => {
        const $link = $(el);
        if ($link.find('.u-skew-link').length === 0) {
            $link.html('<span class="d-ib u-skew-link">' + $link.text() + '</span>');
        }
    });

    $body.on('click', '.default-image', e => {
        if ($('html').hasClass('using-mouse')) {
            return true;
        }
        e.preventDefault();
        e.stopPropagation();
        return false;
    });
};

require('doc-ready')(init);
